<template>
  <div class="systemPrompt">
    <h1 class="title">系统提示</h1>
    <div class="complete">
      <div>
        <!-- <p style="margin:0;">
          <img src="../../assets/complete2.png">
        </p> -->
        <p class="friendly-tips" style="margin-top:120px;">当前你还未完成账户安全设置，系统需要你完成设置！</p>
        <p class="friendly-tips">当你忘记密码时，方便找回密码。</p>
        <!-- <p style="font-size:16px;color:#333333;margin-bottom:45px;">当前你的密码安全性低，就差一步就可以完成密码修改！</p> -->
      </div>
      <!-- <el-button type="info" plain>稍后修改密码</el-button> -->
      <el-button type="primary" @click="setBasicInfo">知道了，马上去设置</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    setBasicInfo () {
      this.$router.push('/SaftySetting/BasicInfo')
    }
  }
}
</script>
<style lang="scss">
.systemPrompt {
  width: 1020px;
  margin: 0 auto;
  background: rgb(255, 255, 255);
  .title {
    font-weight: normal;
    font-size: 24px;
    margin: 30px 40px;
    color: #333333;
    border-bottom:1px solid #eeeeee;
    padding-bottom: 20px;
  }
  .complete {
    text-align: center;
    img {
      margin: 50px 0 30px 0;
    }

    .el-button {
      margin-top: 20px;
      background-color: #1060ab;
    }

    .friendly-tips {
      margin-left: 10px;
      font-size: 24px;
      margin: 0;
      margin-bottom: 20px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/saftySetting/systemPrompt.vue